var React = require('react');

function Memo1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m0 40v40h40 40v120 120h-40-40v40 40h160 160v-40-40h-40-40v-160-160h-120-120z","fill":"#fcd444"}));
}

Memo1.defaultProps = {"height":"400","viewBox":"0 0 320 400","width":"320"};

module.exports = Memo1;

Memo1.default = Memo1;
